module.exports = __webpack_public_path__ + "zvetseni-prsou_58_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_58_before.jpg
// module id = 1352
// module chunks = 0